import { useEffect, useState } from "react";

function getSavedValue(key, initialValue) {
  const savedValue = JSON.parse(localStorage.getItem(key));

  if (savedValue) return savedValue;

  if (initialValue instanceof Function) return initialValue();
  return initialValue;
}

export default function useLocal(key, initialValue) {
  const [value, setValue] = useState(() => {
    return getSavedValue(key, initialValue);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value]);

  return [value, setValue];
}

export const gridContainterVariants = {
  hidden: { opacity: 0 }, show: {opacity: 1, transition: {staggerChildren: 0.10}} 
}
export const gridCubeVariants = {
  hidden: {opacity: 0},
  show: {opacity: 1}
}